import TextInputPage from '@app-studio-web/ui/pages/TextInputPage'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'complete_sentence'

export default function CompleteSentencePage() {
  const submit = useSubmit()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('value') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: "Complete the sentence: I'm someone who...",
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <TextInputPage
      heading="pages.onboarding.completeSentence.heading"
      placeholder="pages.onboarding.completeSentence.placeholder"
      onSubmit={onSubmit}
    />
  )
}
